import { APIError } from '@localagent/sdk';

export function workspaceArchiveFailureMessage(error: unknown): string {
  if (error instanceof APIError) return error.message;
  if (error instanceof Error) return error.message;
  return String(error);
}
